import { IGeneralWarning } from 'next-common';
import { useClientLazyQuery } from './useClientLazyQuery';
import { NEXT_ENTITY } from '@common/interfaces';

interface IUseGeneralWarning {
  data: IGeneralWarning;
  loading: boolean;
  getGeneralWarning: () => void;
}

export const useGeneralWarning = (): IUseGeneralWarning => {
  const [generalWarning, { loading, data }] = useClientLazyQuery(NEXT_ENTITY.GENERAL_WARNING, {
    nextOptions: { cache: 'no-store' },
    variables: {},
  });

  return { data, loading, getGeneralWarning: generalWarning };
};
